/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_PRODUCT = gql`
    query GetProduct($productId: ID!) {
        getProduct(productId: $productId) {
            _id
            name
            lname
            description
            ingredients
            instructions
            subtitle
            images
            desc {
                desc_type
                val
                lang
            }
            gtins {
                _id
                item
                name
                from
                price
                quantityMetric
                gtinKey
                updatedAt
                quantity
            }
            updatedAt
            createdAt
            website
            assets {
                others {
                    height
                    src
                    width
                    asset_type
                }
                imgs {
                    height
                    src
                    width
                    asset_type
                }
                videos {
                    src
                    height
                    width
                }
            }
            attrs {
                name
                val
                disp_type
                disp_val
                isHidden
                tz
            }
        }
    }
`;
